$( document ).ready(function() {
//collection list Slider 
var swiper = new Swiper(".itg_collection_list", {
  slidesPerView: 6,
  centeredSlides: true,
  autoplay:false,
  loop: true,
  spaceBetween: 30,
  slideToClickedSlide: false,
  watchSlidesVisibility: true,
  scrollbar: {
    el: ".itg_collection_scrollbar",
    hide: false,
    draggable: false,
  },
  navigation: {
            prevEl: '.itg_all_swiper-button-prev',
            nextEl: '.itg_all_swiper-button-next',
    },
  breakpoints: {
    1025: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
     480: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },
});

  
//featured tab click js  
  
$('.Itg_featured_coll .tab').on("click", function(){
    // alert('kk');
   $('.tab').removeClass('checked');
  $(this).addClass('checked');
        
  var collectionId = $(this).attr('data_class');
  //alert(collectionId);
       	
  $('.itg_faetured_tab').each(function(){
  	var featured_content = $(this).attr('id');
       // alert(featured_content);
  	if( collectionId == featured_content ){
  		$(this).addClass('active_tab');				
  	}else{
  	$(this).removeClass('active_tab');		 
  	}
  });		
       
});


//testimonials slider  

new Swiper('.itg_test_slide', {
    loop: true,
    autoplay:true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 20,
   scrollbar: {
    el: ".itg_test_swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  navigation: {
            prevEl: '.itg_all_swiper-button-prev',
            nextEl: '.itg_all_swiper-button-next',
    },
    breakpoints: {
        1920: {
            slidesPerView: 1,
            spaceBetween: 30
        },
        1028: {
            slidesPerView: 1,
            spaceBetween: 30
        },
        480: {
            slidesPerView: 1,
            spaceBetween: 10
        }
    }
});


new Swiper('.itg_highlight_slide', {
    loop: true,
    autoplay:true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 20,
  navigation: {
            prevEl: '.itg_all_swiper-button-prev',
            nextEl: '.itg_all_swiper-button-next',
    },
    breakpoints: {
      1199: {
            slidesPerView: 3,
            spaceBetween: 30
        },
       990: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        679: {
            slidesPerView: 1,
            spaceBetween: 10
        }
    }
});

  


//new collection list  slider  

var swiper = new Swiper(".itg_new_coll_slide", {
  slidesPerView: 6,
  slideshow:1,
  centeredSlides: false,
  loop: true,
  spaceBetween: 30,
  slideToClickedSlide: false,
   navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
  breakpoints: {
    1024: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    481: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },
});


//hot spot dots click js

$('.hot_spot_ul li .hot_dots').on("click", function(){
     //alert('kk');
    $(this).parents('.hot_spot_ul').find('.hot_dots').toggleClass('rotate');
    $('.hot_products').fadeOut();
    $(this).parents('.hot_spot_ul').find('.hot_products').toggle();
 });

 $('.hot_images img').on("click", function(){
      $('.hot_products').fadeOut();
     $('.hot_dots').removeClass('rotate'); 
 });


// beforeAfter image js codes
$('.beforeAfter').beforeAfter({
    movable: true,
    clickMove: true,
    position: 50,
    separatorColor: '#fafafa',
    bulletColor: '#fafafa',
    onMoveStart: function(e) {
   // console.log(event.target);
    },
    onMoving: function() {
    // console.log(event.target);
    },
     onMoveEnd: function() {
    // console.log(event.target);
    },
});
  
var swiper = new Swiper(".itg_featured_collection_slider", {
  slidesPerView: 1,
  autoplay:true,
  loop: true,
  centeredSlides: true,
  spaceBetween: 30,
  scrollbar: {
    el: ".itg_tabfeatured_scrollbar",
    hide: false,
    draggable: false,
  },
  navigation: {
            prevEl: '.itg_all_swiper-button-prev',
            nextEl: '.itg_all_swiper-button-next',
    },
  breakpoints: {
    1025: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
     480: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    320: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

  


 

  
// product variants show js codes
  
$('.itg_product .itg_variant_label .form__label').on("click", function(){
      // alert('kk');
    $(this).toggleClass('actives_label')
       $(this).parents('.itg_variant_label').find('.itg_variant_show').slideToggle();
});


// read more read less in product page


// jQuery('.read-more-collection').click(function(){
//       if(jQuery('#truncated').is(":visible")){
//       jQuery('#truncated').hide();
//        jQuery('#fullDescription').slideDown();
//        }
//     else{
//       jQuery('#fullDescription').slideUp();
//       jQuery('#truncated').show();
//     }
// });


// product tab jq start

// Show the first tab and hide the rest
$('.product_tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('.product_tabs-nav li').click(function(){
  $('.product_tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

  
  

//custom add cart button show hide

$(document).on("click",".itgcustom_variant label",function() {
    //alert("click");
  $('.metafiled_btn').show();
  $('.theme_addcartbtn').hide();
});



$('.div_scroller a').click(function(){
    var el = $(this).attr('href');
    var elWrapped = $(el);

    scrollToDiv(elWrapped,130);
    return false;

});
function scrollToDiv(element,navheight){
    var offset = element.offset();
    var offsetTop = offset.top;
    var totalScroll = offsetTop-navheight;

    $('body,html').animate({
    scrollTop: totalScroll
    }, 200);
}

// new variant js codes

  // $(document).on("click",".itg_var_flex label",function() {
    
  //      $(this).closest('.multiple_productlist').find('label').removeClass('active');
  //      var thsadd = $(this).addClass('active');
  //      var mainprice = parseFloat($(document).find('#addonsprice').attr('data-main-price').replace('$',''));
  //       var total = 0;
  //       $('label.radioval.active').each(function(){
  //          total += parseFloat($(this).attr('data-variant_price'));
  //       });
  //       var finalprice = parseFloat(total) + mainprice;
  //       var finalprice = finalprice.toFixed(2);
  //       $(document).find('#addonsprice').text('$'+finalprice);
  // });

  // $(document).on("click",".itg_variant_label label",function() {
  //     setTimeout(function(){
  //       var mainprice = parseFloat($(document).find('#addonsprice').attr('data-main-price').replace('$',''));
  //       var total = 0;
  //       $('label.radioval.active').each(function(){
  //          total += parseFloat($(this).attr('data-variant_price'));
  //       });
  //       var finalprice = parseFloat(total) + mainprice;
  //       var finalprice = finalprice.toFixed(2);
  //       $(document).find('#addonsprice').text('$'+finalprice);
  //       console.log(newdataPrice);
  //     }, 1000);
  // });
   

  $(document).on("click", ".itg_var_flex label", function () {
    $(this).closest(".multiple_productlist").find("label").removeClass("active");
    $(this).addClass("active");
    var mainprice = parseFloat(
      $(document).find("#addonsprice").attr("data-main-price").replace(/[$,]/g, "")
    );
    var total = 0;
    $("label.radioval.active").each(function () {
      total += parseFloat($(this).attr("data-variant_price")) || 0;
    });
    var finalprice = (mainprice + total).toFixed(2);
    $(document).find("#addonsprice").text("$" + finalprice);
    console.log("Final Price:", finalprice);
  });

  $(document).on("click", ".itg_variant_label label", function () {
    setTimeout(function () {
      var mainprice = parseFloat(
        $(document).find("#addonsprice").attr("data-main-price").replace(/[$,]/g, "")
      );
      var total = 0;
      $("label.radioval.active").each(function () {
        total += parseFloat($(this).attr("data-variant_price")) || 0;
      });
      var finalprice = (mainprice + total).toFixed(2);
      $(document).find("#addonsprice").text("$" + finalprice);
      console.log("Final Price:", finalprice);
    }, 1100);
  });


  $(document).on("click","#custom_addtocart",function() {

       var varid = $(document).find('.product-variant-id').val();
       var varqty = $(document).find('.itg_quantity_addcart .quantity__input').val();
        $(this).find('.custom_loader').removeClass('hidden');
        $(this).find('.custom_loader').removeClass('hidden');
         $(this).css("background-color", "#320b0db8");
         $(this).find('span').hide();
        $(this).find('.custom_loader svg circle').css("stroke", "#fff");

         var randomnumber = 1 + Math.floor(Math.random() * 1000);
       
        var available_ids = [];
        $('label.radioval.active').each(function(){
        	    var thisQty = varqty;
              	var xVarID = $(this).attr('for');
              	var toPushItem = xVarID+'-'+thisQty;
              	available_ids.push(toPushItem);
            
        }).promise().done( function(){ 
          //console.log("All done"); 
          //console.log(available_ids);
        });
        var arrylength = available_ids.length;
        if(arrylength == 0){

           var dataarr = {
              "id": varid,
              "quantity": varqty
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: dataarr,
              dataType: 'json',
              success: function() { 
                window.location.href = '/cart'; 
              }
            });
          
        }else{
          
          for (var i = 0; i < available_ids.length; i++) {
            (function(i){
                setTimeout(function(){
                    var formContents = available_ids[i].split('-');

                    var datacart = {
                        "id": formContents[0],
                        "quantity": formContents[1],
                         "properties": {
                           "Rno": randomnumber,
                          }
                      }
                  
                    var params = {
                      type: 'POST',
                      url: '/cart/add.js',
                      data: datacart,
                      dataType: 'json',
                      success: function(line_item) { 
                          var iteration_length = i+1;
                          if( iteration_length == available_ids.length ){ 
                              var dataarr = {
                                "id": varid,
                                "quantity": varqty,
                                "properties": {
                                 "Rno": randomnumber,
                                 }
                              }
                              jQuery.ajax({
                                type: 'POST',
                                url: '/cart/add.js',
                                data: dataarr,
                                dataType: 'json',
                                success: function() { 
                                  window.location.href = '/cart'; 
                                }
                              });
                          }
                      },error: function() {
                          console.log("fail");
                      }
                  };
                  $.ajax(params); 
                }, 1000 * i);
            }(i));
          }
          
        }
  });

   $(document).on("click",".custom_remove_item ",function() {
       var thsnum = $(this).attr('data-num');
           var data = { updates: {} };
          $(document).find('#main-cart-items .cart-item').each(function(){
             var datanumber = $(this).attr('data-number');
             if(datanumber == thsnum){
               var thisKey = $(this).attr('data-key');
               data.updates[thisKey] = 0; 
             }
          });

            jQuery.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: data,
              dataType: 'json',
              success: function(data) { 
               window.location.reload();
              }
            });   

         
   });
     
// fillter change review change in jq start

$(document).on('change', '.select .facet-filters__sort', function(){
        setTimeout(function(){
        location.reload(true);
        }, 500);
});
$(document).on('change', '.mobile-facets__inner .select .select__select', function(){
        setTimeout(function(){
        location.reload(true);
        }, 500);
});
// fillter change review change in jq end 

  
 


  
});



  
